

import { SvgIcon } from "@mui/material";

const HomeExcludeSelected = (props: any) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 28 28">
      <g clipPath="url(#clip0_938_20978)">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.6488 2.61017L24.5651 8.55406C24.9723 8.82556 25.3061 9.19339 25.5369 9.62489C25.7678 10.0564 25.8885 10.5382 25.8884 11.0276V22.9163C25.8885 23.3067 25.8117 23.6932 25.6624 24.0538C25.5131 24.4145 25.2942 24.7422 25.0182 25.0182C24.7422 25.2943 24.4146 25.5132 24.054 25.6626C23.6934 25.812 23.3068 25.8889 22.9165 25.8889H18.6673V15.4583H9.54395V25.8889H5.08326C4.29497 25.8888 3.53901 25.5756 2.98166 25.0181C2.42432 24.4606 2.11125 23.7046 2.11133 22.9163V11.0276C2.11138 10.5382 2.23218 10.0564 2.46302 9.62498C2.69386 9.1935 3.0276 8.82565 3.43465 8.55406L12.3516 2.61017C12.8399 2.28479 13.4135 2.11116 14.0002 2.11116C14.5869 2.11116 15.1605 2.28479 15.6488 2.61017ZM9.54395 25.8889V25.89H18.6673V25.8889H9.91683H9.54395Z" fill="#C72037"/>
      </g>
      <defs>
      <clipPath id="clip0_938_20978">
      <rect width="28" height="28" fill="white"/>
      </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default HomeExcludeSelected;